import { en } from '@/translations/en';
import { es } from '@/translations/es';
import { useEffect, useState } from 'react';

type SupportedLang = 'en' | 'es';

const allTranslations = {
  en,
  es,
};

export function useLocalTranslation() {
  const [lang, setLang] = useState<SupportedLang>(() => {
    return (localStorage.getItem('language') as SupportedLang) || 'en';
  });

  const changeLanguage = (newLang: SupportedLang) => {
    localStorage.setItem('language', newLang);
    setLang(newLang);
  };

  useEffect(() => {
    const storedLang = localStorage.getItem('language') as SupportedLang;
    if (storedLang && storedLang !== lang) {
      setLang(storedLang);
    }
  }, []);

  return {
    ...allTranslations[lang],
    currentLang: lang,
    changeLanguage,
  };
}
